<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    width="270px"
    custom-class="titleDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">
          <img :src="$utils.getPng('web4/icon-circle-fill')" />
          <span>提示</span>
        </div>
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div class="d-content">
        <div class="title">{{ tips }}</div>
      </div>
      <div class="d-footer">
        <fm-button @click="confirm" type="primary" size="small"
          >确 定</fm-button
        >
        <fm-button @click="handleClose" type="info" plain size="small"
          >取 消</fm-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'PromptTip',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    tips: {
      type: String,
      default: '确认取消订阅该订阅号？',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    //提交方法
    confirm: _.debounce(
      function () {
        this.$emit('confirm')
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    handleClose() {
      this.$emit('handleClose')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .titleDialog {
  width: 480px !important;
  .d-header {
    .left {
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }
  .d-content {
    margin: 32px 0 24px 0;
    .title {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      @include useTheme {
        color: getVar('text-color1-2c2c2c');
      }
    }
  }
}
</style>
